import React, { Component } from "react";
import { Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { v4 as uuid } from 'uuid';
import DatePicker from 'react-datepicker';

const required = (val) => val && val.length;
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => (val) && (val.length >= len);
const isNumber = (val) => !isNaN(Number(val));
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);


class AddTaskCommon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            task_id: "",
            task: "",
            desc: "",
            priority: "",
            due: "",
            status: "open",
            topic: "",
            subtopic: "",
            isNavOpen: false,
            isModalOpen: false,
            chkDontClose: false,
            arrSubjects: [],
            arrSubjectsForDate: [],
            arrFilteredSubjects: [],
            subject: "",
            savedMessage: "",
            selectedDate: new Date(),
            startDate: new Date(),
            addTask: false
        }
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSubjectSelect = this.handleSubjectSelect.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        //this.fetchSubjectsForDate = this.fetchSubjectsForDate.bind(this);
        this.updateAllStates = this.updateAllStates.bind(this);
        this.callClearFilter = this.callClearFilter.bind(this);


    }

    callClearFilter() {
        this.props.clearFilter();
    }



    handleDateChange(selectedDate) {
        // console.log ("selectedDate :" + selectedDate);

        const updateDate = new Date(selectedDate)

        this.setState({
            due: updateDate // Update the selected date in the state
        });
    }

    handleSubjectSelect(subject) {
        //alert("clicked me " + subject)
        this.setState(
            {
                subject: subject
            }
        )

    }


    handleFilterChange(event) {

        const filteredSubjects = this.state.arrSubjects.filter(subject =>
            subject.toLowerCase().includes(event.target.value.toLowerCase())
        )

        this.setState({
            arrFilteredSubjects: filteredSubjects,
            subject: event.target.value
        })
    }


    handleChange(event) {
        //alert(event.target.id)
        switch (event.target.id) {
            case "task":
                this.setState({
                    task: event.target.value
                })
                return;
            case "description":
                this.setState({
                    desc: event.target.value
                })
                return;
            case "priority":
                this.setState({
                    priority: event.target.value
                })
                return;
            case "status":
                this.setState({
                    status: event.target.value
                })
                return;
            case "topic":
                this.setState({
                    topic: event.target.value
                })
                return;
            case "subtopic":
                this.setState({
                    subtopic: event.target.value
                })
                return;
            case "subject":
                this.setState({
                    subject: event.target.value
                })
        }

    }


    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }

    toggleModal() {
        //alert("start of toggle modal - isModalOpen :" + this.state.isModalOpen  )
        if (this.state.isModalOpen == true) {
            this.props.updateTaskId(null);
        }

        this.setState({
            isModalOpen: !this.state.isModalOpen
        });

        if (this.props.taskId == null || this.props.taskId == "") {
            this.updateAllStates(this.props.taskId);
        }


        // alert("in toggle modal");
        // alert ("this.props.taskId " + this.props.taskId);
        // alert ("this.state.addTask " + this.state.addTask);
        // alert("end toggle modal");

        // alert ("this.props.taskId togglemodal " + this.props.taskId)

        // alert ("this.state.addTask at togglemodal " + this.state.addTask)

        /*
        create an object called subject with unique subject values derived from the dailylogs props.
        it iterates through dailylog, extracts subjects and creates an object with subject as the key and frequency of the 
        occurence of subject as the value
        */
        const subjects = this.props.timetables.timetables.reduce((acc, day) => {
            const subValue = day.subject;
            if (subValue in acc) {
                acc[subValue]++;
            } else {
                acc[subValue] = 1;
            }
            return acc;
        }, {});

        //alert(JSON.stringify(subjects));

        // Get a sorted list of unique due dates
        const uniquesubjects = Object.keys(subjects).sort((a, b) => a.localeCompare(b));

        //alert (JSON.stringify(this.props.timetables));

        //this.fetchSubjectsForDate(this.state.selectedDate);

        this.setState({
            arrSubjects: uniquesubjects,
            //subject: "",
            savedMessage: ""
        })
        //alert(JSON.stringify(uniquesubjects));


    }

    handleLogin(event) {

        this.toggleModal();
        // alert("Username: " + this.username.value + " Password:" + this.password.value);
        alert("Username: " + this.username.value + " Password:" + this.password.value
            + " Remember: " + this.remember.checked);
        event.preventDefault();
    }

    handleSubmit(values) {
        // alert("in handle submit");
        // alert ("this.props.taskId " + this.props.taskId);
        // alert ("this.state.addTask " + this.state.addTask);
        // alert("end handle submit");


        if (!this.state.chkDontClose) {
            this.toggleModal();
        }




        // alert ("this.props.taskId " + this.props.taskId);

        //const unique_id = uuid();

        if (this.props.taskId != null && this.props.taskId !== "") {
            const tasks = {

                task: this.state.task,
                desc: this.state.desc,
                priority: this.state.priority,
                due: this.state.due,
                status: this.state.status,
                subject: this.state.subject,
                topic: this.state.topic,
                subtopic: this.state.subtopic,
                dailylogid: this.state.dailylogid,
                projectid: "",
                parentid: ""
            }

            //alert(this.props.calledfrom);
            if (this.props.calledfrom == "" || this.props.calledfrom == undefined || this.props.calledfrom == null) {
                this.props.updateTaskCommon(tasks, this.props.taskId, this.callClearFilter);
            }
            else {
                this.props.updateTaskCommon(tasks, this.props.taskId, this.props.updateTaskId);
            }
            // Add this line to set taskID to null
            this.props.updateTaskId(null);

        }
        else {
            const tasks = {
                task: this.state.task,
                desc: this.state.desc,
                priority: this.state.priority,
                due: this.state.due,
                status: this.state.status,
                subject: this.state.subject,
                topic: this.state.topic,
                subtopic: this.state.subtopic,
                dailylogid: this.state.dailylogid,
                projectid: "",
                parentid: ""
            }

            if (this.props.calledfrom == "" || this.props.calledfrom == undefined || this.props.calledfrom == null) {

                this.props.postTaskCommon(tasks, this.callClearFilter);
            }
            else {
                this.props.postTaskCommon(tasks, this.props.updateTaskId);
            }
            // Add this line to set taskID to null
            this.props.updateTaskId(null);
        }


        this.setState({
            savedMessage: "Details Saved"
        })
        //alert("details saved");        
        //console.log("current state is :" + JSON.stringify(values));
        //alert("current state is :" + JSON.stringify(values));
        // alert(this.props.dishId);
        //alert(values.rating);
        //alert(values.author);
        //alert(values.comment);

    }

    componentDidUpdate(prevProps, prevState) {
        /*
        whenever the props being passed to this component is updated from the calling component, this lifecycle method is called.
        we call this mostly when user clicks on a calendar event and we set the calledFrom prop to either calendar or calendar- (we alternate for each click).
        this is mainly because we want to ensure that the TimeTableAdd modal is opened for editing the event even if the user clicks on the same event again and again
        we set isModalOpen to true so that the modal is opened for editing
        */

        // if (this.props.taskId !== prevProps.taskId) {
        //     alert('ismodalopen called for props change')


        // }

        // if (this.state.task !== prevState.task) {
        //     // Do something when 'someState' state changes
        //     alert('ismodalopen called for states change')
        // }

        if (this.props.taskId != null && this.props.taskId !== "") {
            //alert("task id " + this.props.taskId);
            if (!prevState.isModalOpen) {
                this.setState(

                    {
                        isModalOpen: true

                    })


                this.updateAllStates(this.props.taskId);
                //alert("task id " + this.props.taskId);


            }

        }
    }


    updateAllStates(taskId) {



        if (this.props.taskId != null && this.props.taskId !== "") {
            const arrSelectTask = this.props.allTasks.filter(task => task._id == taskId);

            this.setState(

                {
                    task: arrSelectTask[0].task,
                    desc: arrSelectTask[0].desc,
                    priority: arrSelectTask[0].priority,
                    due: new Date(arrSelectTask[0].due),
                    status: arrSelectTask[0].status,
                    subject: arrSelectTask[0].subject,
                    topic: arrSelectTask[0].topic,
                    subtopic: arrSelectTask[0].subtopic,
                    dailylogid: this.props.dailylogid,
                    projectid: "",
                    parentid: ""

                })
        }
        else {
            //alert("this.props.subject :" + this.props.subject);
            this.setState(

                {
                    task: "",
                    desc: "",
                    priority: "",
                    due: "",
                    status: "",
                    subject: this.props.subject,
                    topic: this.props.topic,
                    subtopic: this.props.subtopic,
                    dailylogid: this.props.dailylogid,
                    projectid: "",
                    parentid: ""
                    //addTask: false

                })

        }
    };


    componentDidMount() {


    }

    render() {

        // Create an object to store the counts of tasks for each due date
        //alert(JSON.stringify(this.props.dailylogs));


        return (
            <div>
                <Button outline onClick={this.toggleModal}>
                    <span className="fa fa-pencil fa-lg"></span> Add Task
                </Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal} closeButton>Add Task</ModalHeader>
                    <ModalBody>
                        <Label md={12}>{this.state.savedMessage}</Label>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>

                            <Row className='form-group'>
                                <Label htmlFor="task" md={1}>Task</Label>
                                <Control.text model=".task" id="task" name="task"
                                    placeholder="Task"
                                    className="form-control"
                                    defaultValue={this.state.task}
                                    onChange={(event) => this.handleChange(event)}
                                    validators={{ required, minLength: minLength(3), maxLength: maxLength(100) }}
                                />
                                <Errors className="text-danger"
                                    model=".task"
                                    show="touched"
                                    messages={{
                                        required: 'Required',
                                        minLength: 'Must be greater than 2 characters',
                                        maxLength: 'Must be 100 characters or less'
                                    }}
                                />
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="description" md={12}>Description</Label>
                                <Col md={12}>
                                    <Control.textarea model=".description" id="description" name="description"
                                        rows="6"
                                        defaultValue={this.state.desc}
                                        onChange={(event) => this.handleChange(event)}
                                        className="form-control" />
                                </Col>
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="priority" md={12}>Priority:</Label>
                                <Col md={12}>
                                    <Control.select
                                        model=".priority"
                                        id="priority"
                                        name="priority"
                                        onChange={(event) => this.handleChange(event)}
                                        defaultValue={this.state.priority}
                                        className="form-control"
                                    >
                                        <option value="1">H</option>
                                        <option value="2">M</option>
                                        <option value="3">L</option>

                                    </Control.select>
                                </Col>
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="due" md={12}>Due</Label>
                                <Col md={12}>

                                    <DatePicker
                                        selected={this.state.due}
                                        defaultValue={this.state.due}
                                        onChange={this.handleDateChange}
                                        name="due"
                                        dateFormat="dd/MM/yyyy"
                                        id="due"
                                    />
                                </Col>
                            </Row>



                            <Row className='form-group'>
                                <Label htmlFor="subject" md={12}>Subject</Label>
                                <Col md={12}>
                                    <Control.text model=".subject" id="subject" name="subject"
                                        placeholder="Subject"
                                        className="form-control"
                                        onChange={this.handleFilterChange}
                                        defaultValue={this.state.subject}
                                        value={this.state.subject}
                                    />

                                    {this.state.arrFilteredSubjects.length > 0 && (
                                        <ul>
                                            {this.state.arrFilteredSubjects.map(subject => (
                                                <li key={subject} onClick={() => this.handleSubjectSelect(subject)}>{subject}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {this.state.arrFilteredSubjects.length > 0 && this.state.arrFilteredSubjects.length === 0 && <p>No results found</p>}

                                </Col>
                            </Row>



                            <Row className='form-group'>
                                <Label htmlFor="topic" md={12}>Topic</Label>
                                <Col md={12}>
                                    <Control.text model=".topic" id="topic" name="topic"
                                        defaultValue={this.state.topic}
                                        onChange={(event) => this.handleChange(event)}
                                        placeholder="Topic"
                                        className="form-control"
                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(50) }}
                                    />
                                    <Errors className="text-danger"
                                        model=".topic"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be greater than 2 characters',
                                            maxLength: 'Must be 50 characters or less'
                                        }}
                                    />

                                </Col>
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="subtopic" md={12}>Sub Topic</Label>
                                <Col md={12}>
                                    <Control.text model=".subtopic" id="subtopic" name="subtopic"
                                        onChange={(event) => this.handleChange(event)}
                                        defaultValue={this.state.subtopic}
                                        placeholder="Sub Topic"
                                        className="form-control"
                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(75) }}
                                    />
                                    <Errors className="text-danger"
                                        model=".subtopic"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be greater than 2 characters',
                                            maxLength: 'Must be 75 characters or less'
                                        }}
                                    />

                                </Col>
                            </Row>


                            <Row className='form-group'>
                                <Col md={6}>
                                    <Button type="submit" color="primary">Submit</Button>
                                </Col>
                                <Col md={6}>
                                    <FormGroup check>
                                        <Input
                                            id="chkDontToggle"
                                            type="checkbox"
                                            checked={this.state.chkDontClose}
                                            onChange={(event) => this.handleChange(event)}
                                        />
                                        {' '}
                                        <Label check>
                                            Create more dailylog
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }

}
export default AddTaskCommon;